import { useEffect } from 'react'
import { useAuthStore } from '@/app/store/auth'

/**
 * Hook to initialize and validate authentication state on app startup
 * This ensures that any inconsistent authentication state is cleared
 */
export const useAuthInitialization = () => {
    const initializeAuth = useAuthStore((state) => state.initializeAuth)

    useEffect(() => {
        // Initialize and validate authentication state
        const isValid = initializeAuth()

        if (!isValid) {
            console.log('Authentication state invalidated during initialization')
        }
    }, [initializeAuth])
}
